module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/fire-extinguisher/gage-image.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/fire-extinguisher/gage-image.png
// module id = 562
// module chunks = 0